
import { useEffect, useState } from 'react';
import Footer from './components/Footer';
import Main from './components/Main';
import Sidebar from './components/Sidebar';

function App() {
  const [data, setData] = useState();
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const getAPIData = async () => {
      const API_KEY = process.env.REACT_APP_API_KEY;
      const apiUrl = `https://api.nasa.gov/planetary/apod?api_key=${API_KEY}`;

      const today = (new Date()).toDateString()
      const localKey = `NASA-${today}`;

      if (localStorage.getItem(localKey)) {
        const apiData = JSON.parse(localStorage.getItem(localKey));
        setData(apiData)
        console.log('Fetched from cache today')
        return
      }
      localStorage.clear()

      try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        localStorage.setItem(localKey, JSON.stringify(data))
        setData(data);
      } catch (err) {
        console.err('Failed to laod the data', err);
      }
    }
    getAPIData()
  }, [])

  const handleToggleModal = () => {
    setToggle((toggle) => !toggle);
  }

  return (
    <>
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      {data ? (<Main data={data} />) : (
        <div className="loadingState">
          <i className="fa-solid fa-gear"></i>
        </div>
      )}
      {toggle && (
        <Sidebar data={data} handleToggleModal={handleToggleModal} />
      )}
      {data && (
        <Footer data={data} handleToggleModal={handleToggleModal} />
      )}
    </>
  );
}

export default App;
